import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useFormik } from 'formik'
import { map } from 'lodash'
import CheckIcon from '../../../../assets/icons/Check.svg?react'
import CloseIcon from '../../../../assets/icons/Close.svg?react'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useSettingStore } from '../../../../store/storeSetting'
import { LLMToolState } from '../../../../swagger/dto'
import { ActionButton } from '../../ProfilePage/components/ActionButton'

const SELECT_MAP = [
    {
        icon: <CheckIcon stroke="#019555" />,
        name: 'Можно использовать',
        value: LLMToolState.ENABLED,
    },
    {
        icon: <CheckIcon stroke="#ED9121" />,
        name: 'Обязательно использовать',
        value: LLMToolState.ENFORCED,
    },
    {
        icon: <CloseIcon stroke="#EF4848" />,
        name: 'Не использовать',
        value: LLMToolState.DISABLED,
    },
]

export const CallingFunctionsForm = ({ initialValues, data, nameParams }) => {
    const { updateRequest, requestDetail, setRequestSettingLlmTools } = useRequestsStore(
        (state) => state,
    )
    const { toolDetail } = useSettingStore((state) => state)

    const { values, handleSubmit, handleChange, handleBlur, resetForm, isValid, dirty, setValues } =
        useFormik({
            initialValues,
            onSubmit: async (values) => {
                const updateArray = map(data, (param) => {
                    return { name: param.slug, state: values[param.slug] }
                })
                if (requestDetail?.id) {
                    await updateRequest({ threadId: requestDetail.id }, { llm_tools: updateArray })
                } else {
                    setRequestSettingLlmTools(updateArray)
                }
            },
        })

    return (
        <>
            {toolDetail?.length > 0 && (
                <>
                    <Grid>
                        <Typography
                            variant="h5"
                            sx={{
                                mb: 1,
                            }}>
                            Базовые функции
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                mb: 1,
                                color: '#5E626E',
                            }}>
                            Функции, доступные без подключения сторонних сервисов. Вы можете
                            включать или отключать их использование в запросах
                        </Typography>
                    </Grid>
                    <Grid
                        xs={12}
                        sx={{
                            border: '1px solid #F4F4F6',
                            borderRadius: '16px',
                            p: 2,
                            width: '100%',
                        }}>
                        <form onSubmit={handleSubmit}>
                            {map(data, (item, index) => {
                                return (
                                    <Grid mb={2}>
                                        <Stack
                                            direction={{ xs: 'column', md: 'row ' }}
                                            sx={{
                                                mb: 1,
                                                justifyContent: ' space-between',
                                                alignItems: { xs: 'flex-start', md: 'center' },
                                            }}>
                                            <Stack
                                                direction="column"
                                                sx={{ justifyContent: 'space-between' }}>
                                                <Typography
                                                    variant="h5"
                                                    sx={{
                                                        color: '#121317',
                                                        mb: 1,
                                                        maxWidth: '500px',
                                                    }}>
                                                    {item.title}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: '#121317',
                                                        mb: 1,
                                                        maxWidth: '500px',
                                                    }}>
                                                    {item.description}
                                                </Typography>
                                            </Stack>
                                            <Select
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'center',
                                                    },
                                                    transformOrigin: {
                                                        vertical: 'top',
                                                        horizontal: 'left',
                                                    },
                                                }}
                                                sx={{ mr: 1, overflow: 'auto' }}
                                                id={item.slug}
                                                name={item.slug}
                                                value={values[item.slug]}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                color="secondary">
                                                {map(SELECT_MAP, ({ value, name, icon }, index) => {
                                                    return (
                                                        <MenuItem
                                                            value={value}
                                                            key={index}
                                                            sx={{
                                                                borderBottom: '1px solid #F4F4F6',
                                                                p: '10px 16px',
                                                            }}>
                                                            <Grid
                                                                container
                                                                alignItems="center"
                                                                sx={{ width: '100%', m: 0 }}>
                                                                {icon}
                                                                <Typography variant="h6" ml={1}>
                                                                    {name}
                                                                </Typography>
                                                            </Grid>
                                                        </MenuItem>
                                                    )
                                                })}
                                            </Select>
                                        </Stack>
                                        <Divider />
                                    </Grid>
                                )
                            })}
                            <ActionButton
                                id="function_call_settings_save_button"
                                type="submit"
                                disabled={!(isValid && dirty)}
                                variant="contained">
                                Сохранить
                            </ActionButton>
                        </form>
                    </Grid>
                </>
            )}
        </>
    )
}
